import { UseQueryResult, useQuery } from "@tanstack/react-query";
import {
  GetAllMasterSkuTagsRequest,
  GetAllMasterSkuTagsResponse,
  getAllMasterSkuTags,
} from "services/masterSkuTagApi";

export const useGetAllMasterSkuTags = (
  input: GetAllMasterSkuTagsRequest = {}
): UseQueryResult<GetAllMasterSkuTagsResponse, Error> => {
  return useQuery<GetAllMasterSkuTagsResponse, Error>({
    queryKey: [
      "masterSkuTags",
      input.page_number,
      input.row_per_page,
      input.search,
      input.tag_type,
      input.exclusive_group,
      input.is_active,
    ],
    queryFn: () => getAllMasterSkuTags(input),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};
